export default {
    UPLOAD:'Upload now',
    LATER:'Upload later',
    GENERATED:'Already uploaded',
    NO_AGREEMENT: "There is no agreement",
    SIP: "There is no SIP",
}